import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../shared/shared.module';
import { AuthService } from '../auth/auth.service';
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent implements OnInit {
  dataHeadTiltle = '';
  mobile: boolean = false;
  username: string;
  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) 
  {this.dataHeadTiltle = this.routerInit();}

  routerInit(): any{
    this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    )
    .subscribe(() => {

      var rt = this.getChild(this.activatedRoute)

      rt.data.subscribe(data => {
        this.dataHeadTiltle = data.headTitle;
      })
    })

    this.username = localStorage.getItem('usnm');
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  public user_role:any = false;
  public user;
  public privilege;
  ngOnInit(): void {
    $('#DASHBOARD').hide();
    $('#REAL').hide();
    $('#SUMMARY').hide();
    $('#COMPARE').hide();
    $('#LPR').hide();
  }

  logOut() {
    this.privilege = false;
    // this.router.navigate(['/admin/dashboard']);
    this.authService.deauthen();
  }
  
  showInfo(HeadTiltle) {
    switch (HeadTiltle) {
      case 'DASHBOARD':
        $('#DASHBOARD').show();
        break;
      case 'REAL TIME STATUS':
        $('#REAL').show();
        break;
      case 'ENERGY EFFICIENCY SUMMARY':
        $('#SUMMARY').show();
        break;
      case 'BUS PERFORMANCE COMPARISON':
        $('#COMPARE').show();
        break;
      case 'LPR DETAIL':
        $('#LPR').show();
        break;
      default:
        break;
    }
  }

  hideDashboard() { $('#DASHBOARD').hide(); }
  hideReal() { $('#REAL').hide(); }
  hideSummary() { $('#SUMMARY').hide(); }
  hideCompare() { $('#COMPARE').hide(); }
  hideLPR() { $('#LPR').hide(); }
}
